import { DataGrid, GridColumns } from '@material-ui/data-grid';
import React from 'react';
import { Form } from 'react-bootstrap';
import { ContainerTable } from './styles';
import { useAlteracaoIbsCbsLote } from '../../hooks/useAlteracaoIbsCbsLote';

export const Table: React.FC = () => {
  const { loadingTable, rows, handleCheckProduct } = useAlteracaoIbsCbsLote();
  const columns: GridColumns = [
    {
      field: 'cod_loja',
      headerName: 'Loja',
      headerAlign: 'center',
      align: 'center',
      width: 150,
      sortable: false,
    },
    {
      field: 'cod_produto',
      headerName: 'Código',
      width: 180,
      sortable: false,
    },
    {
      field: 'des_produto',
      headerName: 'Descrição',
      width: 450,
      sortable: false,
    },
    {
      field: 'des_ibs_cbs',
      headerName: 'IBS/CBS',
      headerAlign: 'center',
      width: 230,
      sortable: false,
    },
    {
      field: 'des_classif_trib',
      headerName: 'Classif. Trib.',
      headerAlign: 'center',
      align: 'right',
      width: 250,
      sortable: false,
    },
    {
      field: 'actions',
      headerName: 'Transferir?',
      headerAlign: 'center',
      align: 'center',
      width: 150,
      sortable: false,
      headerClassName: 'hideRightSeparator',
      renderCell: (row: any) => {
        return (
          <Form.Check
            style={{ cursor: 'pointer' }}
            checked={row.row.flg_transfer}
            onClick={() => handleCheckProduct(row.row.uuid)}
          />
        );
      },
    },
  ];
  return (
    <ContainerTable>
      <DataGrid
        className="table"
        loading={loadingTable}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.uuid}
        hideFooter
        hideFooterRowCount
        hideFooterPagination
        disableColumnFilter
        disableColumnSelector
        disableColumnMenu
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado....',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar colunas',
        }}
      />
    </ContainerTable>
  );
};
